import React, { useState, useEffect, useContext } from "react";
import { DateFormatForHistory } from "../../../Utility";
import classes from "./PrivateMarketplace.module.css";
// import { encryptor, isMobile, Activity, currentRequestTimeStamp, NegotiateDateFormatter } from '../../../Constants'
import { isMobile, NegotiateDateFormatter } from "../../../Constants";
import { Urls } from "../../../Urls";
import { toast } from "react-toastify";
import ReactTooltip from "react-tooltip";
import mixpanel from "mixpanel-browser";
import Timeline from "../../TrucksAvailable/NewEnquiry/Summary/Timeline/Timeline";
import ProfileModal from "../../TransporterClientScreen/ProfileModal/ProfileModal";
// import { checkModuleAccess } from '../../../Utility';
import Loader from "../../Loader";
import Axios from "../../../Axios";
import { MyCompanyProfileContext } from "../../../MyCompanyProfileContext";
import { useIndentTracking } from "../hooks/useIndentTracking";
const NewPrivateMarketPlace = ({
  transporter_list,
  item,
  // emailTemplate,
  // userid,
  itemdisable = false,
  closePrivateMarketModal,
}) => {
  const [interestedlist, setList] = useState([]);
  const [rank_list, setRank_list] = useState([]);
  // const [remark, setRemark] = useState('');
  const [show, setshow] = useState(false);
  const [remarkDisable, setremarkDisable] = useState(false);
  const [newtransporter_list, setnewtransporter_list] = useState([]);
  var company_name = localStorage.getItem("companyname");
  var company_mail = localStorage.getItem("useremail");
  var user_name = localStorage.getItem("userdetails");
  const { companySettingData } = useContext(MyCompanyProfileContext);

  const {trackIndentEvent} = useIndentTracking();

  useEffect(() => {
    // Track the event when the user clicks the "view quotation" button.
    trackIndentEvent(
      "indent request", 
      "user has clicked on view quotation button for private marketplace", 
      `Lane: ${item?.indent_info?.origin?.location_name} to ${item?.indent_info?.destination?.location_name}, ${item?.indent_info?.truck_types?.[0]?.label}`
    )

    // Initialize arrays to hold transporter data and rate list.
    var interested = [];
    var ratelist = [];

    // Update the state with the current list of transporters.
    setnewtransporter_list(transporter_list);

    // Check if transporter_list exists and has elements.
    if (transporter_list && transporter_list.length > 0) {
      // Iterate over each transporter in the list.
      transporter_list.map((transporter) => {
        // Check if the transporter has a rate list and it's not empty.
        if (transporter.ratelist && transporter.ratelist.length > 0) {
          // Add the rate of the transporter to the rate list.
          ratelist.push(parseInt(transporter.rate));

          // Initialize additional properties for the transporter.
          transporter.show_history = false; // Set show_history to false
          transporter.remark = ""; // Initialize remark property with an empty string

          // Check if the last rate in the rate list has a 'negotiated' status.
          if (
            transporter.ratelist &&
            transporter.ratelist.length > 0 &&
            transporter.ratelist[transporter.ratelist.length - 1].bid_status ===
              "negotiated"
          ) {
            // Mark the last rate as changed.
            transporter.ratelist[transporter.ratelist.length - 1].change = true;
          }

          // Add the transporter to the interested list.
          interested.push(transporter);
        }
      });

      // Update state with the unique list of rates.
      setRank_list([...new Set(ratelist)]);

      // Update state with the list of interested transporters.
      setList(interested);
    }
  }, []); // Empty dependency array means this effect runs once after the initial render.

  /**
   // Handles click events on a transporter to mark their rate as negotiated.
 * @param {Object} transporter - The transporter whose quotation is being accepted or rejected.
 */
  const clickHandler = (transporter) => {
    // Create a copy of the interested list.
    var temp = interestedlist.slice();

    // Check if the list is not empty.
    if (temp && temp.length > 0) {
      // Iterate over each transporter in the copied list.
      temp.map((t) => {
        // Check if the transporter ID matches the clicked transporter's ID.
        if (t.transporter_id === transporter.transporter_id) {
          // Set the negotiated rate to the current rate.
          t.negotiated_rate = t.rate;

          // Add a new entry in the rate list with a 'negotiated' bid status.
          t.ratelist.push({ bid_status: "negotiated" });
        }
      });
    }

    // Update the state with the modified list.
    setList(temp);
  };

  /**
// Edits the negotiated rate for a transporter.
 * @param {Object} transporter - The transporter whose quotation is being accepted or rejected.
 */
  const editnegrate = (transporter) => {
    // Create a copy of the new transporter list.
    var temp = newtransporter_list.slice();

    // Check if the list is not empty.
    if (temp && temp.length > 0) {
      // Iterate over each transporter in the copied list.
      temp.map((t) => {
        // Check if the transporter ID matches the ID of the transporter to edit.
        if (t.transporter_id === transporter.transporter_id) {
          // Update the negotiated rate to the last negotiated rate in the rate list, if available.
          t.negotiated_rate =
            t.ratelist[t.ratelist.length - 1] &&
            t.ratelist[t.ratelist.length - 1].negotiated_rate
              ? t.ratelist[t.ratelist.length - 1].negotiated_rate
              : t.rate;

          // Set the 'change' property of the last rate entry to false.
          t.ratelist[t.ratelist.length - 1].change = false;
        }
      });
    }

    // Update the state with the modified list.
    setList(temp);
  };

  /**
   // Adds 500 to the negotiated rate of a transporter.
 * @param {Object} transporter - The transporter whose quotation is being accepted or rejected.
 */
  const addHandler = (transporter) => {
    // Create a copy of the interested list.
    var temp = interestedlist.slice();

    // Check if the list is not empty.
    if (temp && temp.length > 0) {
      // Iterate over each transporter in the copied list.
      temp.map((t) => {
        // Check if the transporter ID matches the ID of the transporter to update.
        if (t.transporter_id === transporter.transporter_id) {
          // Increment the negotiated rate by 500.
          t.negotiated_rate = parseInt(t.negotiated_rate) + 500;
        }
      });
    }

    // Update the state with the modified list.
    setList(temp);
  };

  /**
   // Decreases the negotiated rate of a specified transporter by 500, if the result is positive.
 * @param {Object} transporter - The transporter whose quotation is being accepted or rejected.
 */
  const substractHandler = (transporter) => {
    // Create a copy of the interested list.
    var temp = interestedlist.slice();

    // Check if the list is not empty.
    if (temp && temp.length > 0) {
      // Iterate over each transporter in the copied list.
      temp.map((t) => {
        // Check if the transporter ID matches the ID of the transporter to update.
        if (t.transporter_id === transporter.transporter_id) {
          // Decrease the negotiated rate by 500, ensuring it doesn't go below zero.
          if (parseInt(t.negotiated_rate) - 500 > 0) {
            t.negotiated_rate = parseInt(t.negotiated_rate) - 500;
          }
        }
      });
    }

    // Update the state with the modified list.
    setList(temp);
  };

  // Updates the negotiated rate of a specified transporter based on the input field value.
  const inputChangeHandler = (e, transporter, index) => {
    // Update the transporter’s negotiated rate with the value from the input field.
    transporter.negotiated_rate = e.target.value;
  };

  // Updates the remark field of a specified transporter based on the input field value.
  const handleInputChange = (e, transporter, transporterIndex) => {
    // Update the transporter’s remark with the value from the input field.
    transporter.remark = e.target.value;
  };

  /**
   * Handles the acceptance or rejection of a quotation for a transporter.
   * @param {Object} transporter - The transporter whose quotation is being accepted or rejected.
   * @param {string} value - The action to perform, either 'accepted' or 'rejected'.
   */
  const acceptrejectHandler = (transporter, value) => {
    // Confirm the action with the user.
    if (
      window.confirm(
        `Are you sure to ${
          value === "accepted" ? "Accept" : "Reject"
        } the quotation of ${transporter.transporter_name}`
      )
    ) {
      // Track the user's action with Mixpanel.
      trackIndentEvent(
        "indent request", 
        `user has clicked on ${value} quotation button for transporter for private marketplace`, 
        `Lane: ${item?.indent_info?.origin?.location_name} to ${item?.indent_info?.destination?.location_name}, ${item?.indent_info?.truck_types?.[0]?.label}`
      )

      // Prepare payload for the API request.
      const payload = {
        bid_status: value,
        quot_type: transporter.ratelist[transporter.ratelist.length - 1]
          .quot_type
          ? transporter.ratelist[transporter.ratelist.length - 1].quot_type
          : null,
        rate: transporter.rate,
        rate_by: "company",
      };

      // Disable remark input field.
      setremarkDisable(true);

      // Send PUT request to update the quotation status.
      Axios.put(
        `${Urls.indent}?field=view_quotation_private_market&indent_id=${item.indent_id}&transporter_id=${transporter.transporter_id}`,
        payload
      )
        .then((res) => {
          if (
            res &&
            res.data &&
            res.data.status &&
            res.data.status === "update_failed"
          ) {
            alert(res.data.message);
          } else {
            toast.success(
              `Quotation ${
                value === "accepted" ? "Accepted" : "Rejected"
              } for ${transporter.transporter_name}`
            );

            // Update the local list of interested transporters.
            var temp = interestedlist.slice();
            if (temp && temp.length > 0) {
              temp.map((trans) => {
                if (trans.transporter_id === transporter.transporter_id) {
                  trans.ratelist[trans.ratelist.length - 1] = {
                    bid_status: value,
                    quot_type: transporter.ratelist[
                      transporter.ratelist.length - 1
                    ].quot_type
                      ? transporter.ratelist[transporter.ratelist.length - 1]
                          .quot_type
                      : null,
                    rate: transporter.rate,
                    rate_by: "company",
                    rate_submission_date: DateFormatForHistory(new Date()),
                  };
                }
              });
              setList(temp);
            }

            // Close modal if quotation is accepted.
            if (value === "accepted") {
              closePrivateMarketModal();
            }
          }
        })
        .catch((err) => {
          console.log(err);
          setshow(false);
        });
    }
  };

  /**
   * Submits a negotiated rate for a transporter after validation.
   * @param {Object} transporter - The transporter whose negotiated rate is being submitted.
   */
  const submitNegotiatedRate = (transporter) => {
    // Validate the negotiated rate.
    if (parseInt(transporter.negotiated_rate) === parseInt(transporter.rate)) {
      toast.info("Rate and Counter Offer cannot be the same");
    } else if (
      transporter.negotiated_rate === "" ||
      transporter.negotiated_rate === undefined ||
      parseInt(transporter.negotiated_rate) < 0 ||
      transporter.negotiated_rate === null ||
      parseInt(transporter.negotiated_rate) === 0
    ) {
      toast.info("Rate and Counter Offer cannot be empty or 0");
    } else {
      // Show loading indicator.
      setshow(true);

      // Track the user's action with Mixpanel.
      trackIndentEvent(
        "indent request", 
        "user has clicked on negotiate button for private marketplace", 
        `Lane: ${item?.indent_info?.origin?.location_name} to ${item?.indent_info?.destination?.location_name}, ${item?.indent_info?.truck_types?.[0]?.label}`
      )

      // Prepare payload for the API request.
      var payload = {
        bid_status: "negotiated",
        negotiated_at: new Date(),
        negotiated_by: localStorage.getItem("userdetails"),
        negotiated_by_email: localStorage.getItem("useremail"),
        negotiated_rate: transporter.negotiated_rate,
        rate: transporter.rate,
        rate_by: "company",
        remark: transporter.remark,
      };

      // Send PUT request to submit the negotiated rate.
      Axios.put(
        `${Urls.indent}?field=view_quotation_private_market&indent_id=${item.indent_id}&transporter_id=${transporter.transporter_id}`,
        payload
      )
        .then((res) => {
          if (
            res &&
            res.data &&
            res.data.status &&
            res.data.status === "update_failed"
          ) {
            alert(res.data.message);
          } else {
            // Update the local list of interested transporters.
            var temp = interestedlist.slice();
            if (temp && temp.length > 0) {
              temp.map((trans, index) => {
                if (trans.transporter_id === transporter.transporter_id) {
                  trans.ratelist.push({
                    bid_status: "negotiated",
                    negotiated_at: new Date(),
                    negotiated_by: localStorage.getItem("userdetails"),
                    negotiated_by_email: localStorage.getItem("useremail"),
                    negotiated_rate: transporter.negotiated_rate,
                    rate: transporter.rate,
                    rate_by: "company",
                    remark: transporter.remark,
                    change: true,
                  });
                  // Filter out old "negotiated" statuses without a negotiated rate.
                  trans.ratelist = trans.ratelist.filter(
                    (t) =>
                      !(
                        t.bid_status === "negotiated" &&
                        !t.hasOwnProperty("negotiated_rate")
                      )
                  );
                }
              });
              setList(temp);
            }

            // Hide loading indicator and show success message.
            setshow(false);
            toast.success(
              `Counter offer quote submitted to ${transporter.transporter_name}`
            );
          }
        })
        .catch((err) => {
          console.log(err);
          setshow(false);
        });
    }
  };

  /**
   * Cancels the negotiation process for a transporter, either by marking it as changed or removing the negotiation details.
   * @param {Object} transporter - The transporter for whom the negotiation is being canceled.
   */
  const cancelnegotiate = (transporter) => {
    // Check if the transporter has a valid negotiated rate.
    if (
      transporter.ratelist &&
      transporter.ratelist[transporter.ratelist.length - 1].negotiated_rate &&
      transporter.ratelist[transporter.ratelist.length - 1].negotiated_rate !==
        0
    ) {
      var temp = interestedlist.slice();
      if (temp && temp.length) {
        // Mark the last rate list entry as changed.
        temp.map((trans) => {
          if (trans.transporter_id === transporter.transporter_id) {
            trans.ratelist[trans.ratelist.length - 1].change = true;
          }
        });
        setList(temp);
      }
    } else {
      var temp = interestedlist.slice();
      if (temp && temp.length) {
        // Remove the last rate list entry if it is empty or invalid.
        temp.map((trans) => {
          if (trans.transporter_id === transporter.transporter_id) {
            var list = [];
            trans.ratelist.map((val, index) => {
              if (trans.ratelist.length - 1 !== index) {
                list.push(val);
              }
            });
            trans.ratelist = list;
          }
        });
        setList(temp);
      }
    }
  };

  /**
   * Component that displays negotiation options or status for a transporter.
   * @param {Object} props - The component props.
   * @param {Object} props.transporter - The transporter whose negotiation options are being shown.
   * @param {number} props.index - The index of the transporter in the list.
   * @returns {JSX.Element} The rendered component.
   */
  const ShowNegotiation = ({ transporter, index }) => {
    return transporter.ratelist[transporter.ratelist.length - 1]
      .negotiated_rate &&
      transporter.ratelist[transporter.ratelist.length - 1].change === true ? (
      <>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <input
            style={{
              height: "28px",
              margin: "0",
              padding: "0 3px",
              width: "80px",
              textAlign: "center",
            }}
            type="number"
            disabled
            defaultValue={
              transporter.ratelist[transporter.ratelist.length - 1]
                .negotiated_rate
                ? transporter.ratelist[transporter.ratelist.length - 1]
                    .negotiated_rate
                : transporter.rate
            }
          />
          <button
            className={`btn btn-sm btn-primary`}
            style={{ margin: "0 5%", padding: "2% 5%", borderRadius: "50%" }}
            onClick={(e) => editnegrate(transporter)}
            disabled={item.is_expired === true ? true : false}
            title={"Edit Negotiated Rate"}
          >
            <i className={"fa fa-edit"} />
          </button>
          <button
            style={{ margin: "0 5%", padding: "2% 5%", borderRadius: "50%" }}
            disabled
            className={`btn btn-sm btn-success`}
            title="Submit Counter Offer"
          >
            <i className={"fa fa-arrow-right"} style={{ margin: "0" }} />
          </button>
        </div>
        <div style={{ width: "130%" }}>
          <span
            style={{ color: "orange", fontSize: "10px", fontStyle: "italic" }}
          >
            Counter Offer Submitted
          </span>
        </div>
      </>
    ) : (
      <>
        {isMobile() ? (
          ""
        ) : (
          <div style={{ textAlign: "left" }}>Counter Offer:</div>
        )}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            className={`btn btn-sm btn-primary`}
            onClick={(e) => substractHandler(transporter)}
            title={"-500"}
            style={{ margin: "0 2%", padding: "1% 3%" }}
          >
            <i className={"fa fa-minus-circle"} />
          </button>
          <input
            id={`transporter${index}`}
            style={{
              height: "28px",
              margin: "0",
              padding: "0 3px",
              width: "80px",
              textAlign: "center",
            }}
            type="text"
            onChange={(e) => inputChangeHandler(e, transporter, index)}
            defaultValue={transporter.negotiated_rate}
          />
          <button
            className={`btn btn-sm btn-primary`}
            onClick={(e) => addHandler(transporter)}
            title={"+500"}
            style={{ margin: "0 2%", padding: "1% 3%" }}
          >
            <i className={"fa fa-plus-circle"} />
          </button>
          <button
            style={{ margin: "0 1%", padding: "1% 5%", borderRadius: "50%" }}
            className={`btn btn-sm btn-success`}
            title="Submit Counter Offer"
            onClick={(e) => submitNegotiatedRate(transporter)}
          >
            <i className={"fa fa-arrow-right"} style={{ margin: "0" }} />
          </button>
          <button
            onClick={(e) => cancelnegotiate(transporter)}
            style={{ margin: "0 1%", padding: "1% 5%", borderRadius: "50%" }}
            className={`btn btn-sm btn-secondary`}
          >
            <i className={`fa fa-times`} />
          </button>
        </div>
      </>
    );
  };

  /**
   * Component that displays the status of a transporter's bid.
   * @param {Object} props - The component props.
   * @param {Object} props.transporter - The transporter whose status is being shown.
   * @param {number} props.index - The index of the transporter in the list.
   * @returns {JSX.Element} The rendered component.
   */
  const GetStatus = ({ transporter, index }) => {
    return transporter.ratelist && transporter.ratelist.length > 0 ? (
      transporter.ratelist[transporter.ratelist.length - 1].bid_status ===
      "accepted" ? (
        <>
          <span style={{ color: "#54a63a" }}>Accepted</span>
          <br />
          {transporter.ratelist[transporter.ratelist.length - 1].remark ? (
            <span style={{ fontStyle: "italic", fontSize: "12px" }}>
              Remark:{" "}
              {transporter.ratelist[transporter.ratelist.length - 1].remark}{" "}
            </span>
          ) : null}
        </>
      ) : transporter.ratelist[transporter.ratelist.length - 1].bid_status ===
        "rejected" ? (
        <>
          <span style={{ color: "red" }}>Rejected</span>
          <br />
          {transporter.ratelist[transporter.ratelist.length - 1].remark ? (
            <span style={{ fontStyle: "italic", fontSize: "12px" }}>
              Remark:{" "}
              {transporter.ratelist[transporter.ratelist.length - 1].remark}{" "}
            </span>
          ) : null}
        </>
      ) : transporter.ratelist[transporter.ratelist.length - 1].bid_status ===
        "negotiated" ? (
        <ShowNegotiation transporter={transporter} index={index} />
      ) : (
        <>
          {transporter.ratelist[transporter.ratelist.length - 1].bid_status ===
            "accepted" &&
          transporter.ratelist[transporter.ratelist.length - 1].rate_by ===
            "transporter" ? (
            <>
              <button
                className={"btn btn-sm btn-success"}
                style={{
                  margin: isMobile() ? "0 1%" : "1% 5%",
                  padding: isMobile() ? "" : "2% 4%",
                  borderRadius: isMobile() ? "" : "50%",
                }}
                title="Accept"
                disabled={itemdisable || item.is_expired === true}
                onClick={(e) => acceptrejectHandler(transporter, "accepted")}
              >
                {isMobile() ? "Accept" : <i className="fa fa-check" />}
              </button>
              {/*//color:'#54a63a',*/}
              <br />
              <input
                type="textarea"
                onChange={(e) => handleInputChange(e, index)}
                defaultValue={
                  interestedlist[index].remark
                    ? interestedlist[index].remark
                    : ""
                }
                placeholder="Add your remark!"
                style={{ marginBottom: "4%", marginTop: "2%" }}
              />
            </>
          ) : (
            <button
              className={"btn btn-sm btn-success"}
              style={{
                margin: isMobile() ? "0 1%" : "1% 5%",
                padding: isMobile() ? "" : "2% 4%",
                borderRadius: isMobile() ? "" : "50%",
              }}
              title="Accept"
              disabled={itemdisable || item.is_expired === true}
              onClick={(e) => acceptrejectHandler(transporter, "accepted")}
            >
              {isMobile() ? "Accept" : <i className="fa fa-check" />}
            </button>
          )}
          {transporter.ratelist[transporter.ratelist.length - 1]
            .transporter_accepted === true ? null : (
            <>
              <button
                className={"btn btn-sm btn-danger"}
                style={{
                  margin: isMobile() ? "0 1%" : "1% 5%",
                  padding: isMobile() ? "" : "2% 5%",
                  borderRadius: isMobile() ? "" : "50%",
                }}
                title="Reject"
                disabled={itemdisable || item.is_expired === true}
                onClick={(e) => acceptrejectHandler(transporter, "rejected")}
              >
                {isMobile() ? "Reject" : <i className="fa fa-times" />}
              </button>
              <button
                className={"btn btn-sm btn-primary"}
                style={{
                  margin: isMobile() ? "0 1%" : "1% 5%",
                  padding: isMobile() ? "" : "2% 6%",
                  borderRadius: isMobile() ? "" : "50%",
                }}
                title="Give counter offer"
                disabled={itemdisable || item.is_expired === true}
                onClick={(e) => clickHandler(transporter)}
              >
                {isMobile() ? (
                  "Counter Offer"
                ) : // <i className="fa fa-inr" />
                companySettingData?.default_currency?.default_currency
                    ?.symbol ? (
                  <span style={{ fontSize: "13px", fontWeight: "bold" }}>
                    {
                      companySettingData?.default_currency?.default_currency
                        ?.symbol
                    }
                  </span>
                ) : (
                  <i className="fa fa-inr" />
                )}
              </button>

              {index === 0 ? null : (
                <input
                  disabled={remarkDisable === true}
                  type="textarea"
                  onChange={(e) => handleInputChange(e, transporter, index)}
                  defaultValue={
                    interestedlist[index].remark
                      ? interestedlist[index].remark
                      : ""
                  }
                  placeholder="Add your remark!"
                  style={{ marginBottom: "4%", marginTop: "2%" }}
                />
              )}
            </>
          )}
        </>
      )
    ) : null;
  };

  /**
   * Toggles the visibility of the negotiation history for a specific transporter.
   * @param {Object} history_for_transporter - The transporter whose history visibility is being toggled.
   */
  const showHistory = (history_for_transporter) => {
    var transporterList = interestedlist.map((transporter) => {
      if (
        transporter.transporter_id === history_for_transporter.transporter_id
      ) {
        transporter.show_history = !transporter.show_history;
      }
      return transporter;
    });
    setList(transporterList);
  };

  /**
   * Retrieves the lowest bid from the list of interested transporters.
   * This function filters the `interestedlist` to include only those transporters
   * that have a valid rate (i.e., the rate is not undefined, null, or not a number).
   * It then finds the minimum rate among these valid rates and returns it.
   * If no valid rates are found, it returns '--'.
   * @returns {string|number} The lowest bid rate or '--' if no valid bids are found.
   */
  const getLowestBid = () => {
    // Filter the interested list to include only items with a valid rate
    const hasRate = interestedlist.filter(
      (l) =>
        l.rate !== undefined && l.rate !== null && !isNaN(parseFloat(l.rate))
    );

    // If there are no valid rates, return '--'
    if (hasRate.length === 0) {
      return "--";
    }

    // Find the lowest rate from the filtered list
    const lowestRate = Math.min(
      ...hasRate.map((item) => parseFloat(item.rate))
    );

    // Return the lowest rate
    return lowestRate;
  };

  return (
    <>
      <Loader show={show} />
      {newtransporter_list &&
      newtransporter_list !== undefined &&
      newtransporter_list.length > 0 &&
      interestedlist &&
      interestedlist !== undefined &&
      interestedlist.length > 0 ? (
        <>
          <div className="row">
            <div className="col-md-7">
              <div className="row">
                <div
                  className="col-md-3"
                  style={{ fontSize: "14px", paddingRight: "0%" }}
                >
                  <span># Responses received :</span>
                </div>
                <div className="col-md-7" style={{ fontSize: "16px" }}>
                  <span style={{ fontWeight: "bold" }}>
                    {interestedlist.length}
                  </span>
                </div>
                <div
                  className="col-md-3"
                  style={{
                    fontSize: "14px",
                    marginTop: "2%",
                    paddingRight: "0%",
                  }}
                >
                  <span>Lowest Quote (L1) :</span>
                </div>
                <div
                  className="col-md-7"
                  style={{ fontSize: "16px", marginTop: "2%" }}
                >
                  <span style={{ fontWeight: "bold" }}>
                    {/* {interestedlist && interestedlist.length > 0 ? 
                                    Math.min(...interestedlist.map(item => parseFloat(item.rate))) :
                                    ''} */}
                    {/* {interestedlist && interestedlist.length > 0 ?
                                    Math.min(...interestedlist.map(item => {
                                        const rate = parseFloat(item.rate);
                                        return !isNaN(rate) ? rate : '-';
                                    })) :
                                    ''} */}
                    {interestedlist && interestedlist.length > 0
                      ? getLowestBid()
                      : "--"}
                  </span>
                </div>
                <div
                  className="col-md-3"
                  style={{
                    fontSize: "14px",
                    marginTop: "2%",
                    paddingRight: "0%",
                  }}
                >
                  <span>L1 Transporter Name :</span>
                </div>
                <div
                  className="col-md-7"
                  style={{ fontSize: "15px", marginTop: "2%" }}
                >
                  {interestedlist.length > 0 && (
                    <>
                      {(() => {
                        const transporterWithLowestRate = interestedlist.reduce(
                          (minTransporter, currentTransporter) =>
                            parseFloat(currentTransporter.rate) <
                            parseFloat(minTransporter.rate)
                              ? currentTransporter
                              : minTransporter,
                          interestedlist[0]
                        );

                        return (
                          <ProfileModal
                            buttonClass={`btn-link ${classes["transporter_name"]}`}
                            transporter_list={interestedlist}
                            transporter_name={
                              transporterWithLowestRate.transporter_name
                            }
                            transporter_id={
                              transporterWithLowestRate.transporter_id
                            }
                            screenName={"LoRRI Adhoc"}
                            moduleName={"My Enquiries"}
                          />
                        );
                      })()}
                    </>
                  )}
                </div>
              </div>
              {/* {item.is_expired === true ? <h5 style={{color:'black', fontSize:'16px', fontStyle:'italic', fontWeight: 'bold'}}>Note: This Indent is expired!</h5> : null} */}
            </div>
            {isMobile() ? null : (
              <div className="col-md-5">
                <div
                  style={{
                    border: "1px solid #e0e0e0",
                    width: "100%",
                    fontSize: "12px",
                    padding: "2%",
                    borderRadius: "5px",
                  }}
                >
                  <label style={{ fontSize: "12px" }}>Legend:</label>
                  <br />
                  <div className={`row`}>
                    <div
                      className={`col-md-4`}
                      style={{ padding: "0% 0% 0% 3%" }}
                    >
                      <button
                        className={"btn btn-sm btn-success"}
                        style={{
                          padding: "2% 4%",
                          margin: "2%",
                          borderRadius: "50%",
                        }}
                      >
                        {<i className="fa fa-check" />}
                      </button>{" "}
                      - {"Accept"}
                    </div>
                    <div className={`col-md-3`} style={{ padding: "0%" }}>
                      <button
                        className={"btn btn-sm btn-danger"}
                        style={{
                          padding: "2% 7%",
                          margin: "2%",
                          borderRadius: "50%",
                        }}
                      >
                        <i className="fa fa-times" />
                      </button>{" "}
                      - Reject
                    </div>
                    <div className={`col-md-5`} style={{ padding: "0%" }}>
                      <button
                        className={"btn btn-sm btn-primary"}
                        style={{
                          padding: "2% 4%",
                          margin: "2%",
                          borderRadius: "50%",
                        }}
                      >
                        <i className="fa fa-tag" />
                      </button>{" "}
                      - Negotiated Rate
                    </div>
                  </div>
                  <div className={`row`}>
                    <div
                      className={`col-md-5`}
                      style={{ padding: "0% 0% 0% 3%" }}
                    >
                      <button
                        className={"btn btn-sm btn-primary"}
                        style={{
                          padding: "2% 6%",
                          margin: "2%",
                          borderRadius: "50%",
                        }}
                      >
                        {/* <i className="fa fa-inr" /> */}
                        {companySettingData?.default_currency?.default_currency
                          ?.symbol ? (
                          <span
                            style={{ fontSize: "13px", fontWeight: "bold" }}
                          >
                            {
                              companySettingData?.default_currency
                                ?.default_currency?.symbol
                            }
                          </span>
                        ) : (
                          <i className="fa fa-inr" />
                        )}
                      </button>{" "}
                      - Counter Offer
                    </div>
                    <div className={`col-md-3`} style={{ padding: "0%" }}>
                      <button
                        className={"btn btn-sm btn-info"}
                        style={{
                          padding: "2% 5%",
                          margin: "2%",
                          borderRadius: "50%",
                        }}
                      >
                        <i className="fa fa-history" />
                      </button>{" "}
                      - History
                    </div>
                    {/* <div className={`col-md-5`} style={{padding: '0%'}}>
                                    <button className={"btn btn-sm btn-success"} style={{padding:'1% 4%', margin:'2%', borderRadius:'50%'}}>
                                        {/* <i className="fa fa-exclamation" /> */}
                    {/* <i className="fa fa-dot-circle-o" aria-hidden="true"></i> */}
                    {/* </button> - Final Negotiated Rate by Transporter */}
                    {/* </div> */}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
            {isMobile() ? (
              <div>
                {interestedlist && interestedlist.length > 0
                  ? interestedlist.map((tl, index) => {
                      return (
                        <div className={classes["mob-transporter"]}>
                          <div>
                            <b>Rank: </b>
                            {rank_list && rank_list.length > 0
                              ? rank_list.map((rank, i) => {
                                  if (rank === parseInt(tl.rate)) {
                                    return <span>{i + 1}</span>;
                                  }
                                })
                              : null}
                          </div>
                          <div>
                            <b>Transporter Name</b>
                            {tl.transporter_name ? (
                              // <a href={`/tpmp/${encryptor(tl.transporter_id, true)}`} target="_blank" rel="noopener noreferrer">{Uppercase(tl.transporter_name)}</a>
                              <ProfileModal
                                transporter_id={tl.transporter_id}
                                transporter_name={tl.transporter_name}
                                screenName={"LoRRI Adhoc"}
                                moduleName={"My Enquiries"}
                              />
                            ) : (
                              // item.benchmark_transporter_list.map((val) => {
                              //     if(val.transporter_id === tl.transporter_id){
                              //         return <ProfileModal
                              //             transporter_list={interestedlist}
                              //             transporter_id={val.transporter_id}
                              //             transporter_name={val.transporter_name}
                              //             screenName={'LoRRI Adhoc'}
                              //             moduleName={'My Enquiries'}
                              //         />
                              //         // <a href={`/tpmp/${encryptor(tl.transporter_id, true)}`} target="_blank" rel="noopener noreferrer">{Uppercase(val.transporter_name)}</a>
                              //     }
                              // })
                              ""
                            )}
                          </div>
                          <div>
                            <b>Rate: </b>
                            {tl.rate}
                            {(tl.quot_type === "counter_offer_quote" ||
                              tl.quot_type === "quote_after_rejection") &&
                            tl.ratelist[tl.ratelist.length - 1].bid_status !==
                              "accepted" ? (
                              <i className={`fa fa-tag`} />
                            ) : null}
                          </div>
                          <div>
                            <b>Timestamp: </b>
                            {tl.rate_submission_date
                              ? NegotiateDateFormatter(tl.rate_submission_date)
                              : null}
                          </div>
                          {/* <div><b>Interest Status: </b>{tl.interest_data && tl.interest_data.length > 0 ? 
                                    tl.interest_data[tl.interest_data.length - 1].interest_status === 'not_interested' ? 
                                        'Not Interested':
                                        tl.interest_data[tl.interest_data.length - 1].interest_status === 'Interested'? 
                                        'Interested' : 
                                        tl.interest_data[tl.interest_data.length - 1].interest_status ==='not_operating'? 
                                        'Do Not Operate':
                                        'Interested'
                                    : 'Interested' }</div> */}
                          <div>
                            <div>
                              {tl.ratelist && tl.ratelist.length > 0 ? (
                                <div style={{ margin: "0" }}>
                                  <div>
                                    <b>Status: </b>
                                  </div>
                                  <GetStatus transporter={tl} index={index} />
                                </div>
                              ) : (
                                "-"
                              )}
                            </div>
                            <div
                              style={{ width: isMobile() ? "250px" : "600px" }}
                            >
                              <div style={{ display: "flex", margin: "3% 0" }}>
                                <div>
                                  <b>History:</b>
                                </div>
                                {/* <button className={`btn btn-sm btn-secondary`} style= {{float:'right', marginTop:'-3%',padding:'1px 4px'}} onClick={e => showHistory(tl)}><i className="fa fa-arrow-left" />Back</button> */}
                                <button
                                  className={`btn btn-sm btn-info`}
                                  style={{
                                    margin: isMobile() ? "" : "1% 5%",
                                    padding: isMobile() ? "0 1%" : "10% 20%",
                                    borderRadius: isMobile() ? "" : "50%",
                                  }}
                                  onClick={(e) => showHistory(tl)}
                                >
                                  <i className={`fa fa-history`} />
                                </button>
                              </div>
                              {tl.show_history ? (
                                <div>
                                  <Timeline
                                    ratelist={tl.ratelist}
                                    enquiry={item}
                                    index={index}
                                  />
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : null}
              </div>
            ) : (
              <table table-layout="fixed" className={`${classes["s-tablee"]}`}>
                <thead>
                  <tr>
                    <th style={{ width: "5%", textAlign: "center" }}>Rank</th>
                    <th style={{ width: "25%", paddingLeft: "2%" }}>
                      Transporter Name
                    </th>
                    <th style={{ width: "12%", textAlign: "center" }}>
                      Quotation {""}
                      {/*`(${companySettingData?.default_currency ?? "₹ (INR)"})` */}
                      {/* (${companySettingData?.default_currency?.default_currency?.symbol (companySettingData?.default_currency?.default_currency?.cc) ?? "₹ (INR)"}) */}
                      {companySettingData?.default_currency?.default_currency
                        ?.symbol ?? <i className="fa fa-inr" />}
                      <i
                        className={"fa fa-info-circle"}
                        data-tip
                        data-for={"desc1"}
                        style={{ margin: "0 2%" }}
                      ></i>
                      <ReactTooltip
                        id="desc1"
                        place="top"
                        effect="float"
                        backgroundColor="#393185 !important"
                      >
                        <span>
                          <i className="fa fa-tag" /> - Negotiated Rate
                        </span>
                        <br />
                      </ReactTooltip>
                    </th>
                    <th style={{ width: "25%", paddingLeft: "7%" }}>
                      Bid Status
                      <i
                        className={"fa fa-info-circle"}
                        data-tip
                        data-for={"desc"}
                        style={{ margin: "0 2%" }}
                      ></i>
                      <ReactTooltip
                        id="desc"
                        place="top"
                        effect="float"
                        backgroundColor="#393185 !important"
                      >
                        <span>
                          <i className="fa fa-check" /> - Accepted
                        </span>
                        <br />
                        <span>
                          <i className="fa fa-times" style={{ color: "red" }} />{" "}
                          - Rejected
                        </span>
                        <br />
                        <span>
                          {/* <i className="fa fa-inr" /> */}
                          {companySettingData?.default_currency
                            ?.default_currency?.symbol ? (
                            <span
                              style={{ fontSize: "13px", fontWeight: "bold" }}
                            >
                              {
                                companySettingData?.default_currency
                                  ?.default_currency?.symbol
                              }
                            </span>
                          ) : (
                            <i className="fa fa-inr" />
                          )}
                          - Negotiate
                        </span>
                        <br />
                        <span>
                          <i className="fa fa-history" /> - History
                        </span>
                        <br />
                      </ReactTooltip>
                    </th>
                    <th style={{ width: "15%", textAlign: "center" }}>
                      Timestamp
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {/* {console.log(interestedlist,'interestedlist')} */}
                  {interestedlist && interestedlist.length > 0
                    ? interestedlist
                        .sort((a, b) => {
                          if (a.rate !== "" && b.rate === "") {
                            return -1;
                          } else if (a.rate === "" && b.rate !== "") {
                            return 1;
                          } else if (a.rate === "" && b.rate === "") {
                            return 0;
                          } else {
                            return parseFloat(a.rate) - parseFloat(b.rate);
                          }
                        })
                        .map((tl, index) => {
                          const rank =
                            tl.rate !== "" && parseInt(tl.rate) > 0
                              ? index + 1
                              : null;

                          return (
                            <tr key={index}>
                              <td>
                                {rank !== null ? <span>{rank}</span> : null}
                              </td>
                              <td>
                                {tl.transporter_name ? (
                                  <ProfileModal
                                    transporter_list={interestedlist}
                                    transporter_id={tl.transporter_id}
                                    transporter_name={tl.transporter_name}
                                    screenName={"LoRRI Adhoc"}
                                    moduleName={"My Enquiries"}
                                  />
                                ) : // <a href={`/tpmp/${encryptor(tl.transporter_id, true)}`} target="_blank" rel="noopener noreferrer">{Uppercase(tl.transporter_name)}</a>:
                                // item.benchmark_transporter_list.map((val) => {
                                //     if(val.transporter_id === tl.transporter_id){
                                //         return <ProfileModal
                                //         transporter_list={interestedlist}
                                //         transporter_id={tl.transporter_id}
                                //         transporter_name={tl.transporter_name}
                                //         screenName={'LoRRI Adhoc'}
                                //         moduleName={'My Enquiries'}
                                //         />
                                //         // <a href={`/tpmp/${encryptor(tl.transporter_id, true)}`} target="_blank" rel="noopener noreferrer">{Uppercase(val.transporter_name)}</a>
                                //     }
                                // })
                                null}
                              </td>
                              {tl.show_history ? (
                                <td colSpan="4">
                                  <div style={{ width: "600px" }}>
                                    <div>
                                      <div>History</div>
                                      {/* <div style={{display:'flex', justifyContent:'center', fontSize:'10px'}}>
                                                    <i className="fa fa-circle" style={{color:'#393186', margin:"4px 1%"}}/> - By Company User
                                                    <i className="fa fa-circle" style={{color:'#54a63a', margin:"4px 1%"}}/> - By Transporter
                                                </div> */}
                                      <button
                                        className={`btn btn-sm btn-secondary`}
                                        style={{
                                          float: "right",
                                          marginTop: "-3%",
                                          padding: "1px 4px",
                                        }}
                                        onClick={(e) => showHistory(tl)}
                                      >
                                        <i className="fa fa-arrow-left" />
                                        Back
                                      </button>
                                    </div>
                                    <div>
                                      <Timeline
                                        rate_list={tl.ratelist}
                                        enquiry={item}
                                        index={index}
                                        type={"indent"}
                                      />
                                    </div>
                                  </div>
                                </td>
                              ) : (
                                <>
                                  <td
                                    data-tip
                                    data-for={
                                      tl.ratelist &&
                                      tl.ratelist.length > 0 &&
                                      (tl.ratelist[tl.ratelist.length - 1]
                                        .bid_status === "pending" ||
                                        tl.ratelist[tl.ratelist.length - 1]
                                          .bid_status === "rejected") &&
                                      (tl.ratelist[tl.ratelist.length - 1]
                                        .quot_type === "counter_offer_quot" ||
                                        tl.ratelist[tl.ratelist.length - 1]
                                          .quot_type ===
                                          "quote_after_rejection")
                                    }
                                  >
                                    <span style={{ marginRight: "6%" }}>
                                      {tl.rate}
                                    </span>
                                    {tl.ratelist &&
                                    tl.ratelist.length > 0 &&
                                    (tl.ratelist[tl.ratelist.length - 1]
                                      .bid_status === "pending" ||
                                      tl.ratelist[tl.ratelist.length - 1]
                                        .bid_status === "rejected") &&
                                    (tl.ratelist[tl.ratelist.length - 1]
                                      .quot_type === "counter_offer_quot" ||
                                      tl.ratelist[tl.ratelist.length - 1]
                                        .quot_type ===
                                        "quote_after_rejection") ? (
                                      <>
                                        <i
                                          className={`fa fa-tag`}
                                          style={{
                                            cursor: "pointer",
                                            color: "black",
                                          }}
                                          data-tip
                                          data-for={"negotiated-rate"}
                                        />
                                        <ReactTooltip
                                          id="negotiated-rate"
                                          place="bottom"
                                          effect="float"
                                          backgroundColor="#393185 !important"
                                        >
                                          Negotiated Rate
                                        </ReactTooltip>
                                      </>
                                    ) : null}
                                  </td>
                                  <td>
                                    {tl.ratelist && tl.ratelist.length > 0 ? (
                                      <div
                                        className={`row`}
                                        style={{ margin: "0" }}
                                      >
                                        <div className={`col-md-9`}>
                                          <GetStatus
                                            transporter={tl}
                                            index={index}
                                          />
                                        </div>
                                        <div className={`col-md-3`}>
                                          <button
                                            className={`btn btn-sm btn-info`}
                                            style={{
                                              margin: "1% 5%",
                                              padding: "10% 20%",
                                              borderRadius: "50%",
                                            }}
                                            onClick={(e) => showHistory(tl)}
                                          >
                                            <i className={`fa fa-history`} />
                                          </button>
                                        </div>
                                      </div>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td>
                                    {tl.rate_submission_date
                                      ? NegotiateDateFormatter(
                                          tl.rate_submission_date
                                        )
                                      : null}
                                  </td>
                                </>
                              )}
                              {/* <td>{tl.interest_data && tl.interest_data.length > 0 ? 
                                    tl.interest_data[tl.interest_data.length - 1].contact_number
                                : null}</td> */}
                            </tr>
                          );
                        })
                    : null}
                </tbody>
              </table>
            )}
          </div>
        </>
      ) : (
        <span>No Data Found</span>
      )}
    </>
  );
};

export default NewPrivateMarketPlace;
